/**
 * fields/types/index.ts — rejestracja wszystkich 20 typów pól MVP w FieldRegistry.
 *
 * Side-effect import: w bootstrapie aplikacji (App.tsx lub main.tsx) wywołać
 *   `import '@/components/fields/types';`
 * by zarejestrować wszystkie typy. Można też importować pojedyncze:
 *   `import { TextFieldType } from '@/components/fields/types/TextFieldType';`
 *
 * @see notatki/sessions/sesja-2026-05-07-module-creator-brainstorm.md (D2 — 20 typów MVP)
 */

import { FieldRegistry } from '../FieldRegistry';

import { AutonumberFieldType } from './AutonumberFieldType';
import { CheckboxFieldType } from './CheckboxFieldType';
import { CountryFieldType } from './CountryFieldType';
import { CurrencyFieldType } from './CurrencyFieldType';
import { DateFieldType } from './DateFieldType';
import { DatetimeFieldType } from './DatetimeFieldType';
import { DecimalFieldType } from './DecimalFieldType';
import { EmailFieldType } from './EmailFieldType';
import { FileFieldType } from './FileFieldType';
import { ImageFieldType } from './ImageFieldType';
import { MultiselectFieldType } from './MultiselectFieldType';
import { NumberFieldType } from './NumberFieldType';
import { PhoneFieldType } from './PhoneFieldType';
import { RadioFieldType } from './RadioFieldType';
import { RelationFieldType } from './RelationFieldType';
import { SelectFieldType } from './SelectFieldType';
import { TextareaFieldType } from './TextareaFieldType';
import { TextFieldType } from './TextFieldType';
import { UrlFieldType } from './UrlFieldType';
import { UserFieldType } from './UserFieldType';

// Tekst (5)
FieldRegistry.register(TextFieldType);
FieldRegistry.register(TextareaFieldType);
FieldRegistry.register(EmailFieldType);
FieldRegistry.register(PhoneFieldType);
FieldRegistry.register(UrlFieldType);
// Liczby (3)
FieldRegistry.register(NumberFieldType);
FieldRegistry.register(DecimalFieldType);
FieldRegistry.register(CurrencyFieldType);
// Data (2)
FieldRegistry.register(DateFieldType);
FieldRegistry.register(DatetimeFieldType);
// Selekcja (4)
FieldRegistry.register(SelectFieldType);
FieldRegistry.register(MultiselectFieldType);
FieldRegistry.register(CheckboxFieldType);
FieldRegistry.register(RadioFieldType);
// Media (2)
FieldRegistry.register(FileFieldType);
FieldRegistry.register(ImageFieldType);
// Relacje (2)
FieldRegistry.register(RelationFieldType);
FieldRegistry.register(UserFieldType);
// Specjalne (2)
FieldRegistry.register(CountryFieldType);
FieldRegistry.register(AutonumberFieldType);

// ── F12.B batch 1 — proste typy (10) — side-effect imports (auto-register) ──
import './ToggleFieldType';
import './RatingFieldType';
import './PercentFieldType';
import './TimeFieldType';
import './DateRangeFieldType';
import './ColorFieldType';
import './SliderFieldType';
import './HiddenFieldType';
import './PasswordFieldType';
import './TagsFieldType';
// ── F12.B batch 2 — średnie typy (10) — side-effect imports (auto-register) ──
import './CheckboxGroupFieldType';
import './RichTextFieldType';
import './MarkdownFieldType';
import './CodeFieldType';
import './JsonFieldType';
import './AddressFieldType';
import './BarcodeFieldType';
import './QRCodeFieldType';
import './IconFieldType';
import './PrimaryAttachmentFieldType';
// ── F12.B batch 3 — złożone typy (8) — side-effect imports (auto-register) ──
import './SignatureFieldType';
import './GalleryFieldType';
import './AudioFieldType';
import './VideoFieldType';
import './LocationFieldType';
import './FormulaFieldType';
import './LookupFieldType';
import './RollupFieldType';
